import { EventEmitter } from "@angular/core";
import { User } from "../modules/common/user/User";

export let userChanged: EventEmitter<User> = new EventEmitter<User>();
